import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { getHintCanShow } from '../store/hint/selectors/getHintCanShow';
import { isWindowMobile } from '../../main/navigationPanel/constants';

export const cardScrollCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.CARD_SCROLL);
    if (!hint) return false;
    const isMobile = isWindowMobile();
    if (isMobile) return false;

    return !!getHintCanShow(state, EHintKey.CARD_SCROLL);
};
